import React from 'react';
import dayjs from 'dayjs';
import { LinearProgress, Button, Box } from '@material-ui/core';
import { useSelector } from 'react-redux';

import Loader from 'components/Loader';
import { Expiration } from 'plugins/wbu/react';
import { getCustomerPropertyFn } from 'plugins/wbu/utils';

import RenewalTooltip from '../RenewalTooltip';

import useDataTable from './useDataTable';
import { Left, Right } from './components';

function DataTableStandardCustomers() {
  const {
    customer,
    customerRewardPoints,
    expired,
    extraData,
    formatCurrency,
    group,
    homeStore,
    lastVisit,
    renewMembership,
    date,
    setDate,
    currentDate,
  } = useDataTable();
  const { getCustomerProperty } = useSelector(getCustomerPropertyFn);

  const ifExtraData = (fn: (ed: NonNullable<typeof extraData>) => any) => {
    if (!extraData) {
      return <LinearProgress />;
    }
    return fn(extraData);
  };
  return (
    <Loader block loadingText="Loading.." show={!extraData}>
      <div
        style={{
          display: 'grid',
          gridAutoFlow: 'column',
          gridTemplateColumns: '1fr 1fr',
        }}
      >
        <Left title="Card number">
          {getCustomerProperty('customerCardNumber', customer)}
        </Left>
        <Left title="Group">{group?.name}</Left>
        <Left title="Birth note">
          {getCustomerProperty('birthNote', customer)}
        </Left>
        <Left title="E-mail">{customer.email}</Left>
        <Left title="Phone">{customer.phone}</Left>
        <Left title="Mobile">{customer.mobile}</Left>
        <Left title="Address">{customer.addresses?.[0]?.address}</Left>
        <Left title="MyWBU username">{customer.webshopUsername}</Left>
        <Left
          title="Lead code"
          style={{
            lineHeight: 1.5,
            height: '5em',
            overflow: 'hidden',
            // if line-clamp is not supported props below will be ignored and '...' will be missing
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
          }}
        >
          {getCustomerProperty('leadCode', customer)}
        </Left>
        <Right title="Reward points">
          {customerRewardPoints?.value === undefined ? (
            <LinearProgress />
          ) : (
            customerRewardPoints.value.toFixed(2)
          )}
        </Right>
        <Right title="Home store">{homeStore?.name}</Right>
        <Right title="Store credit">
          {' '}
          {formatCurrency(customer.availableCredit ?? 0)}
        </Right>
        <Right title="Last visit">{lastVisit?.format('MM/DD/YYYY')}</Right>
        <Right title="Total sales">
          {ifExtraData(ed => formatCurrency(ed.total_sales ?? 0))}
        </Right>
        <Right title="Total visits">{ifExtraData(ed => ed.total_visits)}</Right>
        <Right title="DSC membership end date">
          {ifExtraData(ed => (
            <Expiration expires={ed.dscExpiration} />
          ))}
        </Right>
        {!expired &&
          ifExtraData(ed => (
            <Right
              title={
                <>
                  <span>Membership renewal</span>
                  <RenewalTooltip />
                </>
              }
            >
              <Box display="inline-block">
                <input
                  type="date"
                  value={date}
                  onKeyDown={e => {
                    e.preventDefault();
                  }}
                  min={dayjs(ed.lastPurchaseStartTime).format('YYYY-MM-DD')}
                  onChange={e => setDate(e.target.value)}
                  max="9999-12-31"
                />
                <Button
                  onClick={renewMembership}
                  disabled={date === currentDate}
                >
                  SAVE
                </Button>
              </Box>
            </Right>
          ))}
      </div>
    </Loader>
  );
}

export default DataTableStandardCustomers;
